import { useEffect } from 'react'
import HeadMeta from 'components/common/HeadMeta'
import JsonLd, { volunteerExPageMeta, volunteerExSchema } from 'components/common/schema'
import Template from 'components/cases/volunteerEx'

const VolunteerEx: React.FC = () => {
  useEffect(() => {
    document.querySelector('body').classList.add('non-chat')
  }, [])
  return (
    <>
      <HeadMeta {...volunteerExPageMeta} />
      <JsonLd data={volunteerExSchema} />
      <Template />
    </>
  )
}

export default VolunteerEx
